import { type LoginResponseDto } from '../dto/login.dto';

import { type AuthToken } from '../models/token';

export function loginFromDto(dto: LoginResponseDto): AuthToken {
  return {
    key: dto.access_token.key,
    accessExpiresAt: dto.access_token.access_expires_at,
    refreshExpiresAt: dto.access_token.refresh_expires_at,
  };
}
